import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
// storybook
import { AppModuleStorybook } from '@investec/io-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
// ngxs - store
import { NgxsModule } from '@ngxs/store';
// app routing
import { AppRoutingModule } from './app-routing.module';
// components
import { AppComponent } from './app.component';
import { AboutComponent } from './components/about/about.component';
import { SessionModalComponent } from './components/base-components/session-modal/session-modal.component';
import { SuccessComponent } from './components/success/success.component';
import { environment } from '../environments/environment';
import { OnboardingGlobalState } from './onboarding.state';
// pipes
import { AmountFormatterPipe } from './pipes/amount-formatter.pipe';

@NgModule({
  declarations: [AppComponent, AboutComponent, SuccessComponent, AmountFormatterPipe, SessionModalComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    AppModuleStorybook,
    NgbModule,
    NgxsModule.forRoot([OnboardingGlobalState]),
    // Only include DevTools in development
    ...(environment.production ? [] : [NgxsReduxDevtoolsPluginModule.forRoot()]),
  ],
  providers: [],
  bootstrap: [AppComponent],
  exports: [AmountFormatterPipe],
})
export class AppModule {}
